<template>
<!-- 辞书世界 - 轮播图管理 -->
  <div class="container">
    <div class="operation-condition">
      <div>
        <el-input
          placeholder="请输入轮播图名称"
          v-model.trim="searchInfo"
          style="min-width: 300px;"
        >
          <el-button type="primary" slot="append" @click="searchHandler"
            >搜索</el-button
          >
        </el-input>
      </div>
      <div style="float: right;">
        <el-button v-on:click="addActivity" type="primary" style="width: 80px" v-if="isManage"
          >新建</el-button
        >
        <el-button
          type="danger"
          style="width: 80px"
          v-bind:disabled="delDisable"
          v-on:click="delClick"
          v-if="isManage"
          >删除</el-button
        >
      </div>
    </div>
    <div class="table_div">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6' }"
        >
        <el-table-column align="center" type="selection" width="55"/>
        <el-table-column
          prop="id"
          label="ID"
          width="100"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="name"
          label="轮播图名称"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="bookId"

          align="center"
          label="是否置顶">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.sort=='1'" type="success">是</el-tag>
            <el-tag v-else type="info">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop='sort'
          align="center"
          label="显示顺序">
        </el-table-column>
        <el-table-column
          prop="operate"
          align="center"
          v-if="isManage"
          width="260"
          :key="Math.random()"
          label="操作">
          <template slot-scope="scope">
            <i class="el-icon-view"  @click="handleClickView(scope.row)"></i>
            <i class="el-icon-edit" @click="handleClick(scope.row)"></i>
            <i class="el-icon-delete" @click="handleDeleteClick(scope.row)"></i>
            <i class="iconfont el-icon-mydownloadshuyi_zhiding" @click="handleToTop(scope.row.id)"></i>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.page_num"
          :page-size="pagenation.page_size"
          background
          layout="total, prev, pager, next"
          :total="pagenation.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import bannerApi from '@/api/banner/index.js'
import { mapRequestActions } from '@/utils'
import { MessageBox } from 'element-ui'
import { checkRole } from '../../utils/auth'
export default {
  data () {
    return {
      loading: false,
      dialogVisible: false,
      isManage: false, // 是否是管理用户
      thumbPath: '',
      dialogImageUrl: '',
      optionStatus: '',
      searchInfo: '',
      options: [],
      selectArr: [],
      delDisable: true,
      tableData: [],
      pagenation: {
        page_num: 1,
        page_size: 10,
        total: 0
      }
    }
  },
  created () {
    this.handleBannerList()
    this.isManage = checkRole(['manage'])
  },
  methods: {
    ...mapRequestActions(bannerApi),
    /**
     * 分页
     */
    handleCurrentChange (newPage) {
      this.pagenation = Object.assign({}, this.pagenation, { newPage })
      this.handleBannerList()
    },

    /**
     * 获取banner图片列表
     */
    handleBannerList () {
      this.getBannerListAction({
        module: 1,
        name: this.searchInfo,
        pageNum: this.pagenation.page_num,
        pageSize: this.pagenation.page_size
      }).then(res => {
        if (res.status) {
          this.pagenation = Object.assign({}, this.pagenation, {
            currentPage: 1,
            total: res.result.total
          })
          this.tableData = res.result.rows || []
        }
      })
    },
    searchHandler () {
      this.handleBannerList()
    },
    /**
     * 置顶
     */
    async handleToTop (id) {
      const resultData = await this.toTopSettingAction({ id: id })
      if (resultData.status) {
        this.handleBannerList()
      }
    },

    // selected items change
    handleSelectionChange (arr) {
      this.selectArr = arr
      if (arr.length !== 0) {
        this.delDisable = false
      } else {
        this.delDisable = true
      }
    },
    /**
     * 图片预览
     */
    handleClickView (e) {
      this.dialogVisible = true
      this.thumbPath = this.BaseUrl.baseUrl + e.file.thumbPath || ''
      this.dialogImageUrl = this.BaseUrl.baseUrl + e.file.relativePath || ''
    },
    /**
     * 新增
     */
    addActivity () {
      this.$router.push({
        path: 'banner-manage-add'
      })
    },
    /**
     * 编辑
     */
    handleClick (item) {
      this.$router.push({
        path: '/banner-manage-edit', query: { id: item.id }
      })
    },
    /**
     * 删除 全选操作
     */
    delClick () {
      const _this = this
      MessageBox.confirm('此操作将永久删除该轮播图, 是否继续?', '提示').then(() => {
        const longIds = _this.selectArr.map(item => item.id)
        this.deleteBannerManageAction({ longIds }).then(res => {
          if (res.status) {
            _this.$message({
              type: 'success',
              message: '删除成功'
            })
            _this.handleBannerList()
          } else {
            _this.$message.error({ message: res.data.msg || '删除失败' })
          }
        })
      })
    },
    /**
     * 删除 单选操作
     */
    handleDeleteClick (item) {
      const _this = this
      MessageBox.confirm('此操作将永久删除该轮播图, 是否继续?', '提示').then(() => {
        const longIds = [item.id]
        this.deleteBannerManageAction({ longIds }).then(res => {
          if (res.status) {
            _this.$message.success('删除成功')
            _this.handleBannerList()
          } else {
            _this.$message.error({ message: res.data.msg || '删除失败' })
          }
        })
      })
    }
  }

}
</script>

<style lang='less' scoped>
@import "./index.less";
</style>
